/* vp-pdp.js -- Vegan Protein PDP (Gruns-architecture rebuild)
   Consumes the Liquid data island #vp-data. Prices come from Loop's real
   selling-plan allocations, not an assumed discount. */
(function(){
  "use strict";
  var root = document.querySelector("[data-vp]");
  var raw  = document.getElementById("vp-data");
  if(!root || !raw) return;

  var DATA;
  try { DATA = JSON.parse(raw.textContent); } catch(e){ return; }
  if(!DATA.variants || !DATA.variants.length) return;

  /* Which bag each flavour is sold as when it ships in more than one size. */
  var PREF = { "Brown Sugar Oatmeal": "15" };

  /* Pre-order is carried per variant on the island JSON, off the same
     custom.preorder metafield the rest of the theme reads, so it cannot drift
     from it. It was a flavour-name map, which was wrong for a flavour that is a
     pre-order in one bag size and not the other. */

  /* Merchandising badge, driven by section settings so it needs no code change. */
  var BADGE_LABEL = (DATA.badgeLabel || "").trim();
  var BADGED = {};
  (DATA.badgeFlavors || "").split(",").forEach(function(n){
    n = n.trim(); if(n) BADGED[n.toLowerCase()] = true;
  });

  /* Draft taste notes -- copy, not data. Move to variant metafields for production. */
  var TASTE = {
    "Brown Sugar Oatmeal":"warm brown sugar over slow-cooked oats.",
    "Dole Whip® Strawberry":"bright ripe strawberry, soft-serve sweet.",
    "Chocolate Brownie Batter":"deep cocoa, fudgy, tastes like scraping the bowl.",
    "IHOP® Cinn-A-Stack® Pancakes":"cinnamon roll swirl layered into pancake batter.",
    "IHOP® Pancakes & Syrup":"buttermilk stack with syrup poured over.",
    "IHOP® Double Blueberry Pancakes":"blueberry compote on a warm pancake.",
    "Dole Whip® Pineapple":"tangy tropical pineapple, tastes like the park.",
    "Natural Vanilla":"clean madagascar vanilla.",
    "Frozen Hot Chocolate":"cold, creamy, cocoa-forward."
  };

  /* Calories + scoop weight read off each label. Panel URLs are Shopify Files;
     move these to variant metafields so marketing can swap them. */
  var CDN = "https://cdn.shopify.com/s/files/1/0090/0192/6735/files/";
  var FACTS = {
    "Brown Sugar Oatmeal":{cal:"140",scoop:"32.5g",panel:CDN+"Be_Amazing_Vegan_Protein_Brown_Sugar_Oatmeal_Nutrition_Facts.jpg?v=1780183899"},
    "Dole Whip® Strawberry":{cal:"130",scoop:"34g",panel:CDN+"Dole_Whip_Vegan_Protein_Be_Amazing_Nutrition_Facts.jpg?v=1738931584"},
    "Chocolate Brownie Batter":{cal:"120",scoop:"32g",panel:CDN+"Chocolate_Brownie_Batter_Vegan_Protein_Nutrition_Facts.jpg?v=1738931585"},
    "IHOP® Cinn-A-Stack® Pancakes":{cal:"130",scoop:"35.5g",panel:CDN+"Vegan_Protein_IHOP_CinnaStack.png?v=1768512760"},
    "IHOP® Pancakes & Syrup":{cal:"130",scoop:"34.8g",panel:CDN+"IHOP_Nutrition_Facts_Be_Amazing_Vegan_Protein_Maple_Pancakes.jpg?v=1738693699"},
    "IHOP® Double Blueberry Pancakes":{cal:"140",scoop:"37.4g",panel:CDN+"IHOP_Double_Blueberry_Pancakes_Be_Amazing_Nutrition_Facts.jpg?v=1738688873"},
    "Dole Whip® Pineapple":{cal:"140",scoop:"37.2g",panel:null},
    "Natural Vanilla":{cal:"120",scoop:"32g",panel:CDN+"VeganProtein-Panel_Natural_Vanilla_15_Servings.jpg?v=1779060553"},
    "Frozen Hot Chocolate":{cal:"140",scoop:"38g",panel:CDN+"Frozen_Hot_Chocolate_Nutrition_Facts_Vegan_Protein.jpg?v=1764844248"}
  };

  var INSIDE = ["PURIS® pea protein","pumpkin seed protein (Smooth Protein™)",
    "Aquamin® trace minerals","apple + blueberry fiber","goMCT® oil powder","monk fruit + Reb-M"];

  /* gradients metafield: "Flavor=#a,#b~Other=#c,#d" */
  var GRAD = {};
  (DATA.gradients || "").split("~").forEach(function(pair){
    var kv = pair.split("=");
    if(kv.length === 2) GRAD[kv[0].trim()] = kv[1].split(",").map(function(c){return c.trim();});
  });
  function grad(name){
    var g = GRAD[name] || ["#0d394e","#155870"];
    return "linear-gradient(168deg,color-mix(in srgb," + g[0] + " 34%,transparent),color-mix(in srgb," + g[g.length-1] + " 14%,transparent))";
  }

  /* group variants into one entry per flavour */
  var byFlavor = {};
  DATA.variants.forEach(function(v){
    (byFlavor[v.flavor] = byFlavor[v.flavor] || {})[v.size] = v;
  });
  var F = Object.keys(byFlavor).map(function(name){
    var sizes = byFlavor[name];
    var pick = (PREF[name] && sizes[PREF[name]]) ? PREF[name] : (sizes["25"] ? "25" : Object.keys(sizes)[0]);
    return { n:name, v:sizes[pick], size:pick, preorder:!!sizes[pick].preorder,
             badge: (BADGE_LABEL && BADGED[name.toLowerCase()]) ? BADGE_LABEL : null,
             promo: ((sizes[pick].promo || "").trim() || null),
             t:TASTE[name] || "", f:FACTS[name] || {cal:"",scoop:"",panel:null} };
  });
  if(!F.length) return;
  REF = Math.min.apply(null, F.map(function(f){
    var n = parseInt(f.size, 10); return isNaN(n) ? 99 : n;
  })) || 15;

  /* Selling-plan groups to hide, by group ID or exact group name.
     Loop's "Stater Bundle" group carries a deeper 30% price and is attached
     inconsistently across variants; Be Amazing have chosen not to surface it.
     It must be matched by ID, not name: its merchantCode is "Stater Bundle"
     but its display name is "Subscribe & Save", and Liquid does not expose
     merchantCode. Two other live groups share the name "Subscribe and save",
     so name matching alone would hide the wrong plans. */
  var HIDE = {};
  (DATA.hidePlanGroups || "").split(",").forEach(function(t){
    t = t.trim(); if(t) HIDE[t.toLowerCase()] = true;
  });
  function planAllowed(p){
    if(HIDE[String(p.group).toLowerCase()]) return false;
    var name = (DATA.planGroups || {})[p.group];
    return !(name && HIDE[String(name).trim().toLowerCase()]);
  }

  function money(n){ return "$" + n.toFixed(2); }

  /* Loop stores plan perks as sibling <span>s of markup, each with an empty
     .check-icon span inside. Parse rather than inject: the description is
     merchant-entered, so it is treated as text, never as HTML. */
  function planPerks(plan){
    if(!plan || !plan.desc) return null;
    var box = document.createElement("div");
    box.innerHTML = plan.desc;
    var out = [];
    Array.prototype.forEach.call(box.children, function(sp){
      var t = (sp.textContent || "").replace(/\s+/g, " ").trim();
      if(t) out.push(t);
    });
    if(!out.length){
      var flat = (box.textContent || "").replace(/\s+/g, " ").trim();
      if(flat) out.push(flat);
    }
    return out;
  }
  /* Cadence follows the bag count, after Javvy: buying more means shipping less
     often. The mapping is a setting because the right interval is a
     merchandising call rather than arithmetic. */
  var CADENCE = (DATA.cadenceByBags || "").split(",").map(function(pair){
    var kv = pair.split(":");
    return {q: parseInt(kv[0], 10), d: parseInt(kv[1], 10)};
  }).filter(function(x){ return x.q > 0 && x.d > 0; })
    .sort(function(a, b){ return a.q - b.q; });

  function planDays(p){ var m = /(\d+)\s*days?/i.exec(p.name || ""); return m ? parseInt(m[1],10) : null; }

  /* ---- quantity tiers ------------------------------------------------
     "1:0, 2:5, 3:5" -> [{q:1,pct:0},{q:2,pct:5},{q:3,pct:5}].
     The percentages are display only: the money actually comes off via a
     Shopify automatic cart discount at checkout, so these MUST match a live
     discount or the page quotes a price the customer is not charged. */
  var TIERS = (DATA.qtyTiers || "1:0").split(",").map(function(pair){
    var kv = pair.split(":");
    return {q: parseInt(kv[0],10), pct: parseFloat(kv[1] || 0) || 0};
  }).filter(function(t){ return t.q > 0; });
  if(!TIERS.length) TIERS = [{q:1, pct:0}];

  function tierPct(q){
    var pct = 0;
    TIERS.forEach(function(t){ if(q >= t.q && t.pct > pct) pct = t.pct; });
    return pct;
  }

  var TOPQ = TIERS.reduce(function(m,t){ return t.q > m ? t.q : m; }, 1);
  /* Javvy's top tier is open-ended ("4+ bags"), so the ladder tops out but the
     basket does not. A ceiling still exists to keep the meter honest. */
  var MAXQ = Math.max(TOPQ * 2, 6);
  var REF = 15, REFV = null;   /* both set below, once F exists */
  /* starts empty: Javvy gates the button on "Select at least 1 bag" rather than
     pre-loading a bag the shopper never chose */
  var state = { i:0, qty:0, mode:"sub", planId:null, slots:[] };

  /* ---- bags (mix and match) --------------------------------------------
     state.slots is an ordered list of flavour indices, one per bag, and is the
     only source of truth -- state.qty is always its length. Tapping a flavour
     adds a bag and promotes the tier up to MAXQ, so a tap never does nothing;
     the tier tiles are shortcuts that jump straight to a count. */
  function countOf(i){
    return state.slots.filter(function(x){ return x === i; }).length;
  }
  function syncQty(){ state.qty = state.slots.length; }
  function addBag(i){
    if(state.slots.length >= MAXQ) return false;
    state.slots.push(i); syncQty(); return true;
  }
  function removeBag(i){
    var at = state.slots.lastIndexOf(i);
    if(at < 0) return false;
    state.slots.splice(at, 1); syncQty(); return true;
  }
  /* tier tiles pad with the most recent pick and trim from the end */
  function setBags(n){
    var sl = state.slots;
    while(sl.length < n) sl.push(sl.length ? sl[sl.length - 1] : 0);
    if(sl.length > n) sl.length = n;
    syncQty();
  }
  /* Plan ids are shared across variants within a Loop group, but resolving per
     flavour means a bag attached to a different group still gets a valid
     allocation instead of silently dropping to one-time.

     15-serving bags offer 15 and 30 day cadences; 25-serving bags offer 20, 30
     and 40. A mixed-size basket therefore has no cadence in common, and an exact
     match alone left such a bag at its full one-time price while the page said
     "subscribe & save". Falling back to this bag's nearest interval keeps the
     subscription rate; render() then names any bag whose interval differs. */
  function ownPlan(f, plan){
    if(!plan) return null;
    var ps = (f.v.plans || []).filter(planAllowed);
    if(!ps.length) return null;
    var exact = ps.filter(function(p){ return p.id === plan.id; })[0];
    if(exact) return exact;
    var want = planDays(plan);
    if(want == null) return ps[0];
    var same = ps.filter(function(p){ return planDays(p) === want; })[0];
    if(same) return same;
    return nearest(ps, want);
  }

  /* Nearest interval to `want`, breaking a tie toward the LONGER one. 3 bags of
     25 servings sits exactly between 20 and 40 days, and a stable sort was
     handing it 20 -- 75 servings arriving every 20 days is a stockpile the
     customer cancels over. Shipping a little late is recoverable; shipping far
     too much is not. */
  function nearest(ps, want){
    return ps.reduce(function(best, p){
      var d = planDays(p), bd = planDays(best);
      if(d === null) return best;
      if(bd === null) return p;
      var dd = Math.abs(d - want), db = Math.abs(bd - want);
      if(dd < db) return p;
      if(dd === db && d > bd) return p;
      return best;
    }, ps[0]);
  }
  var el = function(id){ return document.getElementById(id); };

  /* ---- flavour chips ----
     A div rather than a button: each chip now carries its own -/+ stepper, and
     nesting buttons inside a button is invalid HTML. Keyboard handling is wired
     explicitly so the chip stays operable. */
  var chipHost = el("vpChips"); chipHost.className = "vp-chips";
  F.forEach(function(f,i){
    var b = document.createElement("div");
    b.setAttribute("role", "button");
    b.setAttribute("tabindex", "0");
    /* has-tag reserves top padding for the absolutely-positioned badge row */
    b.className = "vp-chip" + ((f.preorder || f.badge) ? " has-tag" : "");
    b.setAttribute("aria-pressed", i===0);
    b.innerHTML = '<span class="bag" style="background:'+grad(f.n)+'"><img src="'+f.v.img+'&width=120" alt=""></span>'+
      /* No price on the row, as Javvy has it -- the ladder carries pricing. The
         serving count stays, since ours vary and it is what distinguishes two
         otherwise identical-looking bags. */
      /* Name, serving count and badge all share one line, and the name alone
         truncates. Absolutely positioning the badge over this line was cutting
         off the longer flavour names; laid out inline it simply takes its width
         and the name gives way to it. */
      '<span class="vp-txt"><span class="vp-head">'+
        '<span class="nmwrap"><span class="nm">'+f.n+"</span></span>"+
        "</span>"+
        /* On every row, always -- Javvy carries the description permanently, which
           is exactly why their rows never change height. Revealing it only on the
           selected row was what made ours grow. */
        /* Servings ride on the description line. Sharing the name's line, they
           left the longer flavour names no room and every third row read
           "IHOP(R) Cinn-A-Stack..." -- and the flavour is the whole decision. */
        '<span class="ct"><span class="pr">'+f.size+" srv</span>"+
          (f.t ? " \u00b7 "+f.t : "")+"</span></span>"+

      /* Javvy's row control: the badge stacked above an Add button, which
         becomes a stepper once there is something to count. Sitting on the name
         line the badge had to shrink and the name had to give way to it; in its
         own block it costs the name nothing. */
      '<span class="vp-rowctl">' +
        ((f.preorder || f.badge)
          ? '<span class="vp-tags">' +
              (f.badge ? '<span class="vb-tag">'+f.badge+"</span>" : "") +
              (f.preorder ? '<span class="po-tag">pre-order</span>' : "") +
            "</span>"
          : "") +
        '<button type="button" class="vp-add">add +</button>' +
        '<span class="vp-step" hidden>' +
          '<button type="button" data-step="-1" aria-label="one fewer">\u2212</button>' +
          "<b>0</b>" +
          '<button type="button" data-step="1" aria-label="one more">+</button>' +
        "</span>" +
      "</span>";

    /* Tap the chip to add one of this flavour, tap its count to drop one, so
       the same flavour can fill several bags. removeBag refuses to go below one
       bag, so the basket is never empty. */
    function bump(delta){
      if(delta > 0) addBag(i); else removeBag(i);
      focusFlavor(i);
      paintFreq();
      paintChips(); paintTiers(); render();
    }
    b.querySelector(".vp-add").addEventListener("click", function(e){
      e.stopPropagation(); bump(1);
    });
    b.querySelector('[data-step="1"]').addEventListener("click", function(e){
      e.stopPropagation(); bump(1);
    });
    b.querySelector('[data-step="-1"]').addEventListener("click", function(e){
      e.stopPropagation(); bump(-1);
    });
    /* the row itself only ever focuses the flavour; adding is the button's job,
       so a tap on the description cannot silently change the basket */
    b.addEventListener("click", function(){
      focusFlavor(i); paintChips(); render();
    });
    b.addEventListener("keydown", function(e){
      if(e.key === "Enter" || e.key === " "){ e.preventDefault(); bump(1); }
    });
    chipHost.appendChild(b);
  });
  var chips = chipHost.querySelectorAll(".vp-chip");

  /* ---- gallery mosaic ----
     Replaces both the old per-flavour thumbnail row (which duplicated the chips)
     and the slide carousel that followed it. Everything a buyer asks about is on
     screen at once: the bag, the numbers, the supplement panel, the comparison. */
  var bensHost = el("vpBens"), panelTile = el("vpPanelTile"), cmpTile = el("vpCmpTile");

  function paintMosaic(){
    var f = F[state.i];

    bensHost.innerHTML =
      "<h4>per scoop" + (f.f.scoop ? " \u00b7 " + f.f.scoop : "") + "</h4>" +
      '<div class="vp-bengrid">' +
        "<div><b>20g</b><span>protein</span></div>" +
        "<div><b>" + (f.f.cal || "\u2014") + "</b><span>calories</span></div>" +
        "<div><b>\u22641g</b><span>sugar</span></div>" +
        "<div><b>2g</b><span>prebiotic fiber</span></div>" +
      "</div>" +
      (f.t ? '<p class="vp-bentaste">Tastes like: ' + f.t + "</p>" : "");

    /* Not the supplement panel: that image is already rendered full width in the
       nutrition-label block below, and at tile size it is 264px wide and
       unreadable. This tile carries the ingredient story instead. */
    panelTile.innerHTML = "<h4>what\u2019s inside</h4>" +
      '<ul class="vp-tileticks">' +
        "<li><b>20g protein</b> from PURIS\u00ae pea and pumpkin seed</li>" +
        "<li><b>1g or less sugar</b>, only from natural flavors</li>" +
        "<li><b>2g prebiotic fiber</b> from blueberries and apples</li>" +
        "<li><b>Aquamin\u00ae</b> 70+ trace minerals</li>" +
      "</ul>";

    /* Two value columns, not four: at 264px a four-column table wrapped "2g" and
       "70+" one character per line. Rows and values come from the full compare
       table further down the page, which keeps all three columns. */
    cmpTile.innerHTML = "<h4>how it compares</h4>" +
      '<table class="vp-tilecmp">' +
        /* the us column is class-marked in the header too, so the label can be
           given the same emphasis as the cells below it */
        '<thead><tr><th></th><th class="us">us</th><th>typical</th></tr></thead><tbody>' +
          '<tr><th>prebiotic fiber</th><td class="us">2g</td>' +
            '<td class="no">\u2715</td></tr>' +
          '<tr><th>trace minerals</th><td class="us">70+</td>' +
            '<td class="no">\u2715</td></tr>' +
          '<tr><th>added sugar</th><td class="us">none</td>' +
            "<td>varies</td></tr>" +
        "</tbody></table>";
  }

  el("vpUsp").innerHTML = (DATA.usp||"").split(",").map(function(u){
    return "<div>"+u.trim()+"</div>"; }).join("");

  el("vpAcc").innerHTML = (DATA.copy||[]).map(function(c){
    return '<details class="vp-det"><summary>'+c.t+'</summary><div class="vp-body"><p>'+c.b+"</p></div></details>";
  }).join("");

  el("vpFlavCount").textContent = F.length + " in stock";


  /* ---- frequency from real Loop plans ---- */
  /* days the bundle should ship on, given how many bags are in it */
  function targetDays(){
    var n = state.slots.length, out = null;
    if(!n) return null;
    CADENCE.forEach(function(c){ if(n >= c.q) out = c.d; });
    return out;
  }
  /* Stated, not chosen. Javvy never offers the interval -- it falls out of how
     many bags you bought -- and a frequency picker is one more decision in front
     of the add-to-cart for something the bag count already answers. Customers
     retime or pause from the subscription portal after the first order. */
  function paintFreq(){
    var f = F[state.i], plans = (f.v.plans || []).filter(planAllowed);
    var box = el("vpFreq");
    /* The cadence line lives inside the subscription card, which stays on screen
       in one-time mode too, so it is painted regardless of the selected mode --
       only the plan actually posted to the cart depends on it. */
    if(!plans.length){ box.textContent = ""; state.planId = null; return; }
    /* Aim for the interval this bag count maps to, and snap to the nearest one
       the flavour actually offers -- 15-serving bags have 15/30 day plans, so a
       40-day target lands on 30. With nothing chosen yet, fall back to roughly
       one scoop a day. */
    var pick = resolveSubPlan(f);
    state.planId = state.mode === "sub" ? pick.id : null;
    var ds = basketDays();
    box.textContent = !ds.length ? pick.name
      : ds.length === 1 ? "every " + ds[0] + " days"
      : "every " + ds.join(" & ") + " days";
  }

  /* The interval a bag lands on, independent of which purchase mode is
     selected. render() needs it in one-time mode too, to price the
     subscription card it is being compared against. */
  function resolveSubPlan(f){
    var plans = (f.v.plans || []).filter(planAllowed);
    if(!plans.length) return null;
    /* Aim for the interval this bag count maps to and snap to the nearest one
       the flavour actually offers -- 15-serving bags have 15/30 day plans, so a
       40-day target lands on 30. With nothing chosen yet, fall back to roughly
       one scoop a day. */
    var aim = targetDays();
    if(aim === null) aim = parseInt(f.size, 10);
    return nearest(plans, aim);
  }

  /* Every distinct interval the current basket would actually be billed on,
     resolved exactly the way the add-to-cart resolves each line. A mixed basket
     genuinely ships on two cycles -- 15-serving bags have no 20-day plan and
     25-serving bags have no 15-day one -- and the card used to state a single
     number for it. */
  function basketDays(){
    var pick = resolveSubPlan(F[state.i]);
    if(!pick) return [];
    if(!state.slots.length){
      var d0 = planDays(pick);
      return d0 ? [d0] : [];
    }
    var seen = {};
    state.slots.forEach(function(si){
      var own = ownPlan(F[si], pick), d = own ? planDays(own) : null;
      if(d) seen[d] = 1;
    });
    return Object.keys(seen).map(Number).sort(function(a,b){ return a - b; });
  }

  function currentPlan(){
    var plans = (F[state.i].v.plans || []).filter(planAllowed);
    for(var i=0;i<plans.length;i++) if(plans[i].id === state.planId) return plans[i];
    return null;
  }

  /* display only: which flavour the hero, mosaic and promo callout describe.
     Counts change through addBag / removeBag. */
  function focusFlavor(i){
    state.i = i;
    var f = F[i];
    el("vpBag").src = f.v.img + "&width=900";
    el("vpBag").alt = f.n + ", " + f.size + " servings";
    el("vpStage").style.background = grad(f.n);
    el("vpFlav").textContent = (f.n + " · " + f.size + " servings").toLowerCase();
    paintMosaic();

    var oldPo = el("vpStage").querySelector(".po");
    if(oldPo) oldPo.remove();
    var oldVb = el("vpStage").querySelector(".vb");
    if(oldVb) oldVb.remove();
    if(f.badge){
      var vb = document.createElement("span");
      vb.className = "vb";
      vb.textContent = f.badge;
      el("vpStage").appendChild(vb);
    }
    /* Wording is deliberate: Rebuy offers the free bag in the cart on a 3:30
       timer and the customer picks its flavour, so this must not read as if a
       second bag is already in the cart. */
    /* The BOGO callout is retired from this PDP -- the offer still runs in the
       Rebuy cart, it just is not announced here. Left as a hidden node rather
       than deleted from the markup because sections/vp-pdp.liquid is refusing
       writes; drop the <p id="vpPromo"> from the section when that clears. */
    var promoEl = el("vpPromo");
    if(promoEl){ promoEl.hidden = true; promoEl.innerHTML = ""; }
    if(f.preorder){
      var po = document.createElement("span");
      po.className = "po";
      po.innerHTML = "pre-order · " + f.size + " servings<b>ships in ~60 days</b>";
      el("vpStage").appendChild(po);
    }
    paintFreq(); render();
    if(!el("vpNld").hidden) buildPane();
  }

  function render(){
    var f = F[state.i], plan = currentPlan();
    var sub = state.mode === "sub" && plan;
    /* The multi-bag discount stacks on top of the subscription price rather
       than replacing it (the live rule applies on subscription and combines
       with product discounts).

       Mirror Shopify's arithmetic exactly instead of taking a naive percentage
       off the line: it floors the discount PER UNIT to whole cents, then
       multiplies. On a $31.99 unit, 5% is 159.95c, which it charges as 159c --
       so 2 bags cost $60.80, not the $60.78 a line-level percentage gives, and
       3 cost $91.20 not $91.17. Verified against /cart.js at both quantities. */
    var pctOff = tierPct(state.qty);
    /* Bags can differ in price ($39.99 for 15 servings, $49.99 for 25), so the
       basket is summed per bag rather than one unit multiplied. */
    var totalC = 0, listC = 0;
    state.slots.forEach(function(si){
      var g = F[si], gp = sub ? ownPlan(g, plan) : null;
      var uc = Math.round((gp ? gp.price : g.v.price) * 100);
      totalC += uc - Math.floor(uc * pctOff / 100);
      listC  += Math.round(g.v.price * 100);
    });
    var total = totalC / 100, listTotal = listC / 100;

    var sp = el("vpStickyPrice");
    if(sp) sp.textContent = money(total);

    /* Both purchase types are on screen at once now, so both prices have to be
       computed whichever one is selected -- the demoted card is only persuasive
       if it is showing its own, worse, per-each. */
    function basket(usePlan){
      var c = 0;
      state.slots.forEach(function(si){
        var g = F[si], gp = usePlan ? ownPlan(g, usePlan) : null;
        var uc = Math.round((gp ? gp.price : g.v.price) * 100);
        c += uc - Math.floor(uc * pctOff / 100);
      });
      return c / 100;
    }
    var n = state.slots.length;
    var subPlan = resolveSubPlan(f);
    /* With nothing chosen yet, quote one bag so the cards are never blank. */
    var subEa  = n ? basket(subPlan) / n : unitAt(1);
    var onceEa = n ? basket(null) / n    : (refBag() || f).v.price;
    var listEa = n ? listTotal / n     : (refBag() || f).v.price;

    el("vpEaSub").textContent  = money(subEa) + "/ea";
    el("vpEaOnce").textContent = money(onceEa) + "/ea";
    var wasEl = el("vpEaWas");
    wasEl.textContent = money(listEa);
    wasEl.hidden = subEa >= listEa - 0.005;

    /* Javvy's ribbon. Ours states the subscription's saving against buying the
       same bags one-time -- and says "every order", not "first order", because
       the Loop discount recurs rather than being a one-off welcome rate. */
    var ribPct = onceEa > 0 ? Math.round((1 - subEa / onceEa) * 100) : 0;
    var rib = el("vpRibbon");
    rib.textContent = "save " + ribPct + "% on every order";
    rib.hidden = ribPct <= 0;

    /* The button carries the total. */
    var totWas = el("vpTotWas"), totNow = el("vpTotNow"), totBox = el("vpAtcPrice");
    if(totBox){
      totBox.hidden = !n;
      totNow.textContent = money(total);
      totWas.textContent = money(listTotal);
      totWas.hidden = total >= listTotal - 0.005;
    }

    /* The border and shadow live on the card wrapper now, so the whole offer
       lights up together; aria-checked stays on the radio itself. */
    var subOn = el("vpOptSub"), onceOn = el("vpOptOnce"), subCard = el("vpCardSub");
    if(subCard) subCard.classList.toggle("is-on", sub);
    subOn.setAttribute("aria-checked", sub ? "true" : "false");
    onceOn.classList.toggle("is-on", !sub);
    onceOn.setAttribute("aria-checked", sub ? "false" : "true");

    /* gift-with-purchase, subscription only -- built as nodes rather than
       innerHTML because the heading and title come from merchant-entered
       settings and metafields */
    /* The gift is now the first line of the perks list rather than its own
       block -- see the note there. Kept as a variable because the perks builder
       and the duplicate-perk filter both read it. */
    var giftBox = el("vpGift"), g = DATA.gift;
    if(giftBox) giftBox.hidden = true;

    el("vpPre").hidden = !f.preorder;
    if(f.preorder) el("vpPre").innerHTML =
      "<b>Pre-order · " + f.size + "-serving bag · ships in about 60 days.</b> Comes with a free $10 gift card, emailed after purchase.";

    /* Prefer Loop's own perks for the selected plan -- they are the promises
       the store actually makes ("Free Hand Mixer with purchase" among them),
       so they cannot drift out of sync with merchandising. Falls back to the
       written list when a plan carries no description. */
    var perks = sub ? planPerks(plan) : null;
    if(!perks || !perks.length){
      perks = sub
        ? ["free shipping over $100","pause, skip or cancel after your 2nd order","swap flavors between deliveries","30-day returns, unopened"]
        : ["_subscriber pricing","_flavor swapping","free shipping over $100","30-day returns, unopened"];
    }
    /* The gift now has its own row with a photo of the thing, so a perk saying
       the same words is the offer stated twice. Matched against the gift's own
       product title rather than a hardcoded "mixer", so it keeps working if
       merchandising swaps the gift. */
    if(sub && g && g.product){
      /* Any one distinctive word is enough. Requiring all of them missed the
         real case: the gift product is "Handheld Mixer" while Loop's perk says
         "Free Hand Mixer with purchase" -- they name the same object without
         sharing every word. Five characters keeps it off "free", "with", "your". */
      var giftWords = g.product.toLowerCase().split(/[^a-z0-9]+/)
        .filter(function(w){ return w.length >= 5; });
      if(giftWords.length) perks = perks.filter(function(t){
        var lt = t.toLowerCase();
        return !giftWords.some(function(w){ return lt.indexOf(w) > -1; });
      });
    }
    /* One flat list at one weight. The card was running six type sizes and three
       bold/regular pairings in 279px -- the gift row and the guarantee row were
       styled identically to each other, so they read as two peer announcements
       competing with the price instead of supporting it. Everything below the
       header is now the same size and the same marker; only the header is bold.

       Order is gains first, risk-removers last:
         gift (the one concrete number, and the only thumbnail)
         Loop's own perks, in Loop's order
         guarantee (strongest safety claim, last thing read before the button)
       The gift and the guarantee are ours to place; the middle comes from the
       selling plan's description, so its internal order is a Loop edit. */
    var rows = [];
    perks.forEach(function(t){ rows.push({ t: t }); });
    if(GUAR) rows.push({ t: GUAR });
    if(sub && g && g.head){
      /* The value is pulled out of the theme's own heading string rather than a
         separate field -- settings.fr_head already interpolates the gift price,
         and the section file that would carry it as its own key is currently
         not writable. */
      var val = (g.head.match(/\$[\d,]+(?:\.\d{2})?/) || [])[0];
      rows.push({
        t: "Free " + String(g.product || "gift").toLowerCase() +
           (val ? " (" + val + " value)" : ""),
        img: g.img
      });
    }

    /* The photograph, back and at a size where it actually reads. A drawn whisk
       needed ~32px to be legible at all -- at 21px it looked like a pin. */
    el("vpPerks").innerHTML = rows.map(function(r){
      var no = r.t.charAt(0) === "_";
      var txt = no ? r.t.slice(1) : r.t;
      /* The image sits at the end of its row, not in place of the tick, so every
         row keeps the same left edge. */
      return '<li class="' + (no ? "no" : "") + (r.img ? " has-img" : "") + '">' +
        txt + (r.img
          ? '<img src="' + r.img + '&width=140" alt="" width="38" height="38" loading="lazy">'
          : "") + "</li>";
    }).join("");

    /* wire the real cart form */
    el("vpVid").value = f.v.id;
    var loopVid = el("vpLoopVid");
    if(loopVid) loopVid.value = f.v.id;
    el("vpSp").value  = sub ? plan.id : "";
    el("vpQty").value = state.qty;
    /* No price here -- it is already the largest thing in the plan card directly
       above. The label stays "add to cart" in both purchase modes; only
       pre-order overrides it, because that is a fact a shopper needs before
       committing. */
    /* Javvy's gate: nothing is preselected, so the button states the next step
       instead of pretending it can add nothing. */
    var atcB = el("vpAtc"), empty = state.slots.length === 0;
    if(atcB) atcB.disabled = empty;
    if(stickySync) stickySync();
    el("vpAtcLabel").textContent = empty ? "select at least 1 bag"
      : (f.preorder ? "pre-order" : "add to cart");
  }

  /* Quantity meter, after Javvy: each rung shows what a bag costs at that
     count, the track fills to where the basket is, and the best rung is
     flagged. It reports rather than selects -- the flavour rows drive it.

     The per-bag figures come from tierPct, so they match what the cart charges.
     Note our ladder is flat after two bags: the live "Buy 2 Save 5%" function
     gives the same $47.50/bag at 2, 3 and 4, so the flag sits on the first rung
     that reaches the best price rather than on the largest. */
  var tierHost = el("vpTiers");
  /* One reference bag, not the focused flavour. Bags genuinely differ in price
     ($39.99 for 15 servings, $49.99 for 25), so keying the ladder off whatever
     the hero happened to show made a single rung read $31.99/ea one moment and
     $39.99/ea the next. The cheapest bag is the reference and the rung says
     "from", which is true at every tier -- Javvy can quote a flat per-each
     because all their bags cost the same. */
  /* Cheapest bag that actually has a selling plan, so the subscription figure on
     the ladder is real rather than inherited. Resolved on first use, not up
     front: planAllowed reads HIDE, which is populated further down, and an
     eager call threw before the chips were ever built. */
  function refBag(){
    if(!REFV){
      REFV = F.filter(function(f){
          return (f.v.plans || []).filter(planAllowed).length > 0;
        }).sort(function(a,b){ return a.v.price - b.v.price; })[0]
        || F.slice().sort(function(a,b){ return a.v.price - b.v.price; })[0];
    }
    return REFV;
  }
  function unitAt(q){
    var f = refBag() || F[state.i], plan = currentPlan();
    /* fall back to this bag's own list price, never to plan.price -- plan
       belongs to whichever flavour the hero is showing, so borrowing it made the
       ladder quote a 25-serving price while claiming to be the cheapest bag */
    var own = (state.mode === "sub" && plan) ? ownPlan(f, plan) : null;
    var base = own ? own.price : f.v.price;
    var uc = Math.round(base * 100);
    return (uc - Math.floor(uc * tierPct(q) / 100)) / 100;
  }
  function paintTiers(){
    if(!tierHost) return;
    var best = null;
    TIERS.forEach(function(t){
      var u = unitAt(t.q);
      if(best === null || u < best.u - 0.001) best = {q:t.q, u:u};
    });
    var n = state.slots.length;
    tierHost.innerHTML = TIERS.map(function(t, idx){
      var top = idx === TIERS.length - 1;
      var reached = n >= t.q;
      var active = reached && (top || n < TIERS[idx+1].q);
      return '<span class="vp-rung' + (reached ? " is-reached" : "") +
        (active ? " is-active" : "") + '" aria-checked="' + active + '">' +
        "<b>" + t.q + (top ? "+" : "") + (t.q === 1 && !top ? " bag" : " bags") +
        "</b><i class=\"dot\"></i><span>from " + money(unitAt(t.q)) + "/ea</span>" +
        (best && t.q === best.q ? '<em class="vp-best-deal">best deal</em>' : "") +
        "</span>";
    }).join("");
    alignRail();
  }

  /* Javvy's meter is joined by a rail that fills to the current tier. Rather
     than guess the dot row's offset in CSS -- which breaks the moment the label
     font renders a shade differently -- measure it and hand CSS the numbers. */
  function alignRail(){
    var dots = tierHost.querySelectorAll(".dot");
    if(!dots.length) return;
    /* rects, not offsetLeft: each .vp-rung is position:relative, so it is the
       dot's offsetParent and every dot reports the same offset within its own
       rung -- which made the rail zero-width */
    var box = tierHost.getBoundingClientRect();
    var midX = function(d){ var r = d.getBoundingClientRect();
      return r.left - box.left + r.width / 2; };
    var midY = function(d){ var r = d.getBoundingClientRect();
      return r.top - box.top + r.height / 2; };
    var first = dots[0], last = dots[dots.length - 1];
    tierHost.style.setProperty("--railY", midY(first) + "px");
    tierHost.style.setProperty("--railX", midX(first) + "px");
    tierHost.style.setProperty("--railW", (midX(last) - midX(first)) + "px");
    var reached = tierHost.querySelectorAll(".vp-rung.is-reached .dot");
    var to = reached.length ? midX(reached[reached.length - 1]) : midX(first);
    tierHost.style.setProperty("--railFill", Math.max(0, to - midX(first)) + "px");
  }
  window.addEventListener("resize", alignRail);

  /* the count lives on the chip itself, so there is no second list to keep in
     sync and no "which bag am I editing" state to explain */
  function paintChips(){
    Array.prototype.forEach.call(chips, function(c, ci){
      var n = countOf(ci);
      /* aria-pressed means "in the basket"; is-focus is only which flavour the
         hero is currently describing, so looking is not mistaken for choosing */
      c.setAttribute("aria-pressed", n > 0);
      c.classList.toggle("is-focus", ci === state.i);
      var add = c.querySelector(".vp-add"), step = c.querySelector(".vp-step");
      if(add && step){
        add.hidden  = n > 0;
        step.hidden = n === 0;
        step.querySelector("b").textContent = n;
        step.querySelector('[data-step="1"]').disabled = state.slots.length >= MAXQ;
        add.disabled = state.slots.length >= MAXQ;
      }
      c.classList.toggle("is-counted", n > 0);
    });
  }
  syncQty(); paintTiers(); paintChips();
  Array.prototype.forEach.call(root.querySelectorAll(".vp-opt"), function(t){
    t.addEventListener("click", function(){
      state.mode = t.dataset.mode; paintFreq(); render();
    });
  });

  /* ---- nutrition drawer ---- */
  var nld = el("vpNld"), lastFocus = null;
  function buildPane(){
    var f = F[state.i];
    var facts = f.f.panel
      ? '<div class="vp-nl-facts"><img src="'+f.f.panel+'" alt="Nutrition facts, '+f.n+'"></div>'+
        '<p class="vp-nl-cap">Label artwork for the '+f.size+'-serving bag. Values are per 1 scoop.</p>'
      : '<p class="vp-nl-none">The label for the '+f.size+"-serving "+f.n+
        " bag has not been published yet. Per-serving values are unchanged from the 25-serving bag: "+
        f.f.cal+" calories, 20g protein, 1g or less sugar.</p>";
    el("vpNldScroll").innerHTML =
      '<p class="vp-nl-eb">vegan protein</p><h2 class="vp-nl-t" id="vpNlTitle">'+f.n+"</h2>"+
      '<dl class="vp-nl-meta"><div><dt>serving size</dt><dd>1 scoop ('+f.f.scoop+')</dd></div>'+
      "<div><dt>servings</dt><dd>"+f.size+" per bag</dd></div></dl>"+
      '<div class="vp-nl-st"><span><b>'+f.f.cal+'</b><i>calories</i></span>'+
      "<span><b>20g</b><i>protein</i></span><span><b>≤1g</b><i>sugar, never added</i></span></div>"+
      '<h3 class="vp-nl-h">what\'s inside</h3><div class="vp-nl-chips">'+
      INSIDE.map(function(x){return "<span>"+x+"</span>";}).join("")+"</div>"+
      '<h3 class="vp-nl-h">free from</h3><div class="vp-nl-chips free">'+
      (DATA.usp||"").split(",").map(function(x){return "<span>"+x.trim()+"</span>";}).join("")+"</div>"+
      '<h3 class="vp-nl-h">nutrition facts</h3>'+facts;
  }
  /* ---- nutrition sheet: open/close, and the scroll lock -----------------
     Reported 2026-10-18: on an iPhone 13 the page "randomly stops scrolling".
     Two faults here, both of which end with `body { overflow:hidden }` applied
     and NOTHING on screen to clear it. Once that happens the page is stuck
     until reload, which is exactly what it looked like.

     1. The teardown timer outlived the drawer. closeNld() hid the sheet on a
        220ms setTimeout. Re-opening inside that window - an ordinary quick
        double tap - re-locked the body and un-hid the sheet, then the STALE
        timer fired and hid it again, orphaning the lock. Reproduced exactly:
        open, close, re-open within 220ms leaves overflow:hidden with the sheet
        at display:none. The timer is now cancelled on open and on close.

     2. The lock landed before the sheet was open. `.open` was added inside a
        requestAnimationFrame, and iOS defers rAF while the page is scrolling
        and in Low Power Mode. Without `.open` the CSS leaves .vp-nld at
        `position:fixed; inset:0; z-index:500; opacity:0` with pointer events
        live - an invisible full-screen sheet over the whole page. Observed in
        this state on a 375x812 touch viewport. Flushing layout and adding the
        class synchronously keeps the fade (the transition still gets a start
        frame) without depending on a frame ever being served.

     The lock is tracked rather than assumed, so unstick() can only ever undo
     OUR lock - the Rebuy cart and the mobile menu set the same property and
     must not be stepped on. */
  var nldTimer = null, weLocked = false;

  function lockScroll(on){
    if(on){ document.body.style.overflow = "hidden"; weLocked = true; }
    else if(weLocked){ document.body.style.overflow = ""; weLocked = false; }
  }

  /* Belt and braces: if the sheet is not open, the page must be scrollable.
     Catches anything above that we have not thought of, including a bfcache
     restore that comes back with the lock still applied. */
  function unstick(){
    if(weLocked && !nld.classList.contains("open")) lockScroll(false);
  }
  window.addEventListener("pageshow", unstick);
  document.addEventListener("visibilitychange", function(){
    if(!document.hidden) unstick();
  });

  el("vpNutOpen").addEventListener("click", function(){
    clearTimeout(nldTimer); nldTimer = null;   /* a pending close would re-hide us */
    lastFocus = document.activeElement; buildPane();
    nld.hidden = false; nld.setAttribute("aria-hidden","false");
    void nld.offsetWidth;                      /* give the fade a start frame */
    nld.classList.add("open");
    lockScroll(true);                          /* only once it is really open */
    el("vpNutClose").focus();
  });
  function closeNld(){
    clearTimeout(nldTimer);
    nld.classList.remove("open"); nld.setAttribute("aria-hidden","true");
    lockScroll(false);
    nldTimer = setTimeout(function(){ nld.hidden = true; nldTimer = null; }, 220);
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }
  el("vpNutClose").addEventListener("click", closeNld);
  nld.addEventListener("click", function(e){ if(e.target.hasAttribute("data-close")) closeNld(); });
  document.addEventListener("keydown", function(e){ if(e.key==="Escape" && !nld.hidden) closeNld(); });

  /* ---- comparison table scroll affordance ---- */
  var sc = el("vpTblScroll");
  if(sc){
    var wrap = sc.parentElement;
    var upd = function(){
      var more = sc.scrollWidth - sc.clientWidth > 4;
      wrap.classList.toggle("at-end", !more || sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 4);
    };
    sc.addEventListener("scroll", upd, {passive:true});
    window.addEventListener("resize", upd);
    upd();
  }

  /* ---- reviews eyebrow ------------------------------------------------
     No count here on purpose. Yotpo reports two different totals for this
     product -- the main reviews widget says 2,617 while the star-ratings
     widget in the buy box says 2,250 -- and the yotpo.* metafields are
     staler still (2,616 / 1,806). The widget prints its own count directly
     below this line, so repeating it would only pick a side. ---- */

  /* ---- reviews category pills ----------------------------------------
     Yotpo already computes real topic filters across the whole review set,
     and its own buttons work when clicked. They are just buried under the
     AI summary and media gallery, capped at eight, and ordered by Yotpo's
     own ranking -- which pushes taste, texture, mixes, stomach and
     substitute behind "Show more". So these pills proxy clicks straight to
     Yotpo's buttons rather than re-implementing filtering: same data, same
     handlers, our order and wording, up beside the headline where the
     objection actually gets answered.

     Driving Yotpo's search box instead does NOT work -- it ignores
     synthetic input events (a nonsense query still returns every review),
     which would have shipped a row of pills that quietly did nothing. ---- */
  var RV_CATS = [
    {topic:"taste",       label:"taste"},
    {topic:"texture",     label:"texture"},
    {topic:"consistency", label:"consistency"},
    {topic:"mixes",       label:"mixes well"},
    {topic:"stomach",     label:"digestion"},
    {topic:"substitute",  label:"vs. other proteins"},
    {topic:"ingredients", label:"ingredients"},
    {topic:"value",       label:"value"}
  ];

  function rvWidget(){ return document.querySelector(".yotpo-reviews-main-widget"); }

  /* name -> button, for every topic Yotpo currently has in the DOM */
  function rvTopicMap(){
    var w = rvWidget();
    if(!w) return null;
    var items = w.querySelectorAll(".yotpo-smart-topics-item");
    if(!items.length) return null;
    var map = {};
    Array.prototype.forEach.call(items, function(li){
      var name = (li.textContent || "").trim().toLowerCase();
      if(name) map[name] = li.querySelector("button") || li;
    });
    return map;
  }

  function rvIsShowToggle(name){ return name === "show more" || name === "show less"; }

  function rvClearActive(map){
    Object.keys(map).forEach(function(name){
      if(rvIsShowToggle(name)) return;
      if(map[name].getAttribute("aria-pressed") === "true") map[name].click();
    });
  }

  function buildRvCats(){
    var host = el("vpRvCats");
    if(!host || host.dataset.built) return false;
    var map = rvTopicMap();
    if(!map) return false;
    /* Yotpo shows eight topics; the useful ones sit behind "Show more" */
    if(map["show more"]){ map["show more"].click(); map = rvTopicMap() || map; }
    var avail = RV_CATS.filter(function(c){ return map[c.topic]; });
    if(avail.length < 3) return false;   /* not enough to be worth a row */

    host.innerHTML =
      '<button type="button" class="vp-rvcat" data-t="" aria-pressed="true">all reviews</button>' +
      avail.map(function(c){
        return '<button type="button" class="vp-rvcat" data-t="' + c.topic +
               '" aria-pressed="false">' + c.label + "</button>";
      }).join("");
    host.hidden = false;
    host.dataset.built = "1";
    /* only now hide Yotpo's own topic row -- if the pills had failed to
       build, its filters stay available rather than being hidden for nothing */
    rvWidget().classList.add("vp-rv-piloted");

    Array.prototype.forEach.call(host.children, function(b){
      b.addEventListener("click", function(){
        var m = rvTopicMap();
        if(!m) return;
        rvClearActive(m);
        var t = b.dataset.t;
        if(t && m[t]) m[t].click();
        Array.prototype.forEach.call(host.children, function(x){
          x.setAttribute("aria-pressed", x === b);
        });
        var list = document.querySelector(".yotpo-reviews-cart-list");
        if(list) list.scrollIntoView({block:"start", behavior:"smooth"});
      });
    });
    return true;
  }

  if(el("vpRvCats") && !buildRvCats()){
    /* Yotpo hydrates lazily on scroll */
    var rvMo = new MutationObserver(function(){ if(buildRvCats()) rvMo.disconnect(); });
    rvMo.observe(document.body, {childList:true, subtree:true});
    setTimeout(function(){ rvMo.disconnect(); }, 30000);
  }

  /* ---- add to cart -------------------------------------------------------
     One /cart/add.js call with an items array, so a mix-and-match basket lands
     as a single request and the drawer opens once. Sections are requested in the
     same call and handed to <cart-drawer>.renderContents -- the path
     product-form.js takes, and the re-render that remounts Rebuy (which is what
     the IHOP BOGO offer rides on).

     The subscription mixer gift goes in the same array: the FREE GIFT function
     keys on the _gwp_item property, and adding it here means one drawer render
     instead of two. Any failure reading the cart falls through without blocking
     the sale, and a gift already present is never stacked. */
  function cartDrawer(){ return document.querySelector("cart-drawer"); }
  function sectionIds(){
    var d = cartDrawer();
    return (d && typeof d.getSectionsToRender === "function")
      ? d.getSectionsToRender().map(function(x){ return x.id; }).join(",")
      : null;
  }

  var stickySync = null;
  var atcBtn = el("vpAtc"), GIFT = DATA.gift;
  if(atcBtn){
    atcBtn.addEventListener("click", function(){
      var plan = currentPlan();
      var sub  = state.mode === "sub" && plan;
      var err  = el("vpAddErr");
      atcBtn.disabled = true; atcBtn.classList.add("loading");
      if(err) err.hidden = true;

      /* two bags of one flavour become one line of quantity 2 */
      var byLine = {}, order = [];
      state.slots.forEach(function(si){
        var g = F[si], own = sub ? ownPlan(g, plan) : null;
        var key = g.v.id + "|" + (own ? own.id : "");
        if(!byLine[key]){
          byLine[key] = { id: g.v.id, quantity: 0 };
          if(own) byLine[key].selling_plan = own.id;
          /* The line-item property snippets/buy-buttons.liquid posts for a
             pre-order. Without it the cart line is not marked and the checkout
             pre-order acknowledgement never fires. Set per line, so a mixed
             basket flags only the bags that really are pre-orders. */
          if(g.v.preorder) byLine[key].properties = { preorder: "true" };
          order.push(key);
        }
        byLine[key].quantity += 1;
      });
      var items = order.map(function(k){ return byLine[k]; });

      var pre = (sub && GIFT && GIFT.id)
        ? fetch("/cart.js", {headers:{Accept:"application/json"}})
            .then(function(r){ return r.json(); })
            .then(function(cart){
              var have = (cart.items || []).some(function(it){
                return String(it.variant_id) === String(GIFT.id);
              });
              if(!have) items.push({
                id: GIFT.id, quantity: 1, properties: {_gwp_item: "true"}
              });
            })
            .catch(function(){})
        : Promise.resolve();

      pre.then(function(){
        var body = { items: items };
        var ids = sectionIds();
        if(ids){ body.sections = ids; body.sections_url = window.location.pathname; }
        return fetch("/cart/add.js", {
          method: "POST",
          headers: {"Content-Type":"application/json", Accept:"application/json"},
          body: JSON.stringify(body)
        }).then(function(r){
          return r.json().then(function(j){ return {ok:r.ok, json:j}; });
        });
      })
      .then(function(res){
        if(!res.ok){
          if(err){
            err.hidden = false;
            err.textContent = res.json.description || res.json.message ||
              "Something went wrong adding to cart.";
          }
          return;
        }
        var d = cartDrawer();
        if(d && res.json.sections && typeof d.renderContents === "function"){
          d.renderContents(res.json);
        } else if(d && typeof d.open === "function"){
          d.open();
        } else {
          window.location = "/cart";
        }
      })
      .catch(function(){
        if(err){
          err.hidden = false;
          err.textContent = "Something went wrong adding to cart. Please try again.";
        }
      })
      .then(function(){
        atcBtn.disabled = false; atcBtn.classList.remove("loading");
      });
    });
  }

  /* ---- mobile buy bar ---- */
  (function(){
    var bar = el("vpSticky"), real = el("vpAtc"), btn = el("vpStickyBtn");
    if(!bar || !real || !btn) return;
    btn.addEventListener("click", function(){ real.click(); });
    /* Held back until the customer reaches the flavour picker. Above it they are
       still reading the hero and have chosen nothing, so a buy bar is just a
       covered-up 60px of page; from the picker down it is the only add-to-cart
       within reach, since the list is no longer height-capped. It mirrors the
       real button's label and disabled state so it never offers an action the
       page will refuse.
       Measured off rects on scroll rather than an IntersectionObserver: this is
       a long page whose sections repaint, and the rect is the same number the
       bar's own position is derived from. */
    var gate = el("vpChips");
    /* Shows while the picker is still a quarter-screen below the top edge --
       roughly 200px earlier on an 812px phone -- so the bar is already there as
       the first flavours come into view. Proportional rather than a fixed pixel
       count, so it lands the same way on a short phone and a tall one.

       Two thresholds, not one. Adding a bag grows the meter above the picker
       (the days line and the tier note appear), which pushes the picker DOWN the
       viewport by 20-60px. With a single threshold, a customer who had just
       scrolled the bar into view watched it vanish the moment they tapped Add --
       their own tap moved the thing being measured back out of range. Retracting
       needs the picker most of a screen away, which no layout shift can cause,
       so only real upward scrolling puts the bar away. */
    var LEAD = 0.25, RELEASE = 0.75;
    var up = false;
    var sync = function(){
      if(gate){
        var top = gate.getBoundingClientRect().top, vh = window.innerHeight;
        if(!up && top <= vh * LEAD) up = true;
        else if(up && top > vh * RELEASE) up = false;
      } else {
        up = true;
      }
      bar.classList.toggle("is-up", up);
      bar.setAttribute("aria-hidden", up ? "false" : "true");
      /* Mirrors the real button: same label, same struck-and-real price pill,
         same disabled state, so the bar never offers what the page refuses. */
      var lbl = el("vpAtcLabel"), slbl = el("vpStickyLbl");
      if(lbl && slbl) slbl.textContent = lbl.textContent;
      var src = el("vpAtcPrice"), dst = el("vpStickyP");
      if(src && dst) dst.hidden = src.hidden;
      var sw = el("vpStickyWas"), rw = el("vpTotWas");
      if(sw && rw){ sw.textContent = rw.textContent; sw.hidden = rw.hidden; }
      btn.disabled = real.disabled;
    };
    window.addEventListener("scroll", sync, {passive:true});
    window.addEventListener("resize", sync);
    /* the label and gate follow the basket, so re-sync whenever it is repainted */
    stickySync = sync;
    sync();
  })();

  /* focusFlavor runs paintFreq, which picks the default cadence -- the ladder
     has to be repainted after that or its first paint quotes list prices
     because currentPlan() was still null. */
  /* The guarantee becomes the last line of the perks list. Captured once from
     the merchant setting, then the standalone node is removed -- as a bold lead
     over a muted sub-line it was styled identically to the gift row, so the two
     read as competing announcements and neither deferred to the price. */
  var GUAR = "";
  (function(){
    var gn = root.querySelector(".vp-guar");
    if(!gn) return;
    var t = (gn.textContent || "").replace(/\s+/g, " ").trim()
      .replace(/^\u2713\s*/, "").trim();
    var cut = t.indexOf(". ");
    GUAR = (cut > -1 ? t.slice(0, cut) : t.replace(/\.$/, "")).toLowerCase();
    gn.parentNode.removeChild(gn);
  })();

  /* ---- hold our own bag art for named flavours -------------------------
     The storefront runs a global image swapper (an inline map of old filename
     -> new "*_dairy-free.png" art) that rewrites <img src> after we render.
     For every flavour but one that is what we want -- it serves the current
     packaging. Pineapple is the exception: its mapped file is
     dolewhip_pineapple_gc_dairy-free.png, the gift-card promo art with a banner
     baked across the top and bottom of the bag. No clean dairy-free pineapple
     exists on the CDN (checked five naming conventions, all 404), so we pin the
     variant's own image instead, which is clean and correctly says 15 Servings.
     Trade-off: it is the pre-rebrand "vegan protein" bag, so pineapple will be
     the one row not showing dairy-free art until that asset is uploaded.
     Implemented as a MutationObserver rather than a one-off assignment because
     the swapper runs after us and can re-run. Restoring the src fires the
     observer once more, then matches and stops. */
  var HOLD_OWN_ART = ["dole whip\u00ae pineapple"];
  function heldFlavor(name){
    return HOLD_OWN_ART.indexOf(String(name || "").toLowerCase().trim()) > -1;
  }
  (function(){
    var queued = false;
    function pin(){
      queued = false;
      [].slice.call(root.querySelectorAll(".vp-chip")).forEach(function(c){
        var nm = c.querySelector(".nm"), img = c.querySelector(".bag img");
        if(!nm || !img || !heldFlavor(nm.textContent)) return;
        var want = F.filter(function(f){ return heldFlavor(f.n); })[0];
        if(!want) return;
        var url = want.v.img + "&width=120";
        if(img.getAttribute("src") !== url) img.setAttribute("src", url);
      });
      var hero = el("vpBag"), f = F[state.i];
      if(hero && f && heldFlavor(f.n)){
        var hurl = f.v.img + "&width=900";
        if(hero.getAttribute("src") !== hurl) hero.setAttribute("src", hurl);
      }
    }
    function queue(){ if(queued) return; queued = true;
      (window.requestAnimationFrame || setTimeout)(pin, 0); }
    if(typeof MutationObserver === "function"){
      new MutationObserver(queue).observe(root, {
        subtree: true, childList: true, attributes: true, attributeFilter: ["src"]
      });
    }
    queue();
  })();

  focusFlavor(0); paintTiers(); paintChips();
})();
